import React from 'react';
import MuiTooltip from '@mui/material/Tooltip';

const AppTooltip = ({
    arrow = true,
    arrowSx,
    children,
    placement = 'top',
    slotProps = {},
    tooltipSx,
    ...props
}) => (
    <MuiTooltip
        arrow={arrow}
        placement={placement}
        slotProps={{
            ...slotProps,
            tooltip: {
                ...slotProps.tooltip,
                sx: [tooltipSx, slotProps.tooltip?.sx].flat().filter(Boolean),
            },
            arrow: {
                ...slotProps.arrow,
                sx: [arrowSx, slotProps.arrow?.sx].flat().filter(Boolean),
            },
        }}
        {...props}
    >
        {children}
    </MuiTooltip>
);

export default AppTooltip;
